import { RootState } from '../store.model';

export const getMyUserId = (state: RootState) => state.auth.id;
